import React from "react";
import { AlertCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";

interface IncompleteSectionProps {
  title?: string;
  path: string;
}

const IncompleteSection: React.FC<IncompleteSectionProps> = ({
  title = "This section is not filled completely yet.",
  path,
}) => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="w-full bg-white border border-gray-200 rounded-3xl p-8 flex flex-col items-center justify-center text-center font-serif pt-24"
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <div className="flex flex-col items-center space-y-4">
        <div className="bg-gray-100 p-4 rounded-full">
          <AlertCircle className="text-yellow-600 w-8 h-8" />
        </div>

        <p className="text-gray-800 text-[17px] font-semibold tracking-wide">
          {title}
        </p>

        <Button
          onClick={() => navigate(path)}
          className="bg-black hover:bg-gray-900 text-white rounded-full px-6 py-2 text-sm font-medium"
        >
          Go Fill the Info 
        </Button>
      </div>
    </motion.div>
  );
};

export default IncompleteSection;
